import React from "react";
import ProfileMenu from "./ProfileMenu";
import NotificationMenu from "./NotificationMenu";
import Search from "./Search";
import LocationMenu from "./LocationMenu/index";
import "./style.scss";
import HelpMenu from "./HelpMenu";

class TopBar extends React.Component {
  render() {
    return (
      <div className="topbar">
        <div className="topbar__left">
          <Search />
        </div>
        <div className="topbar__right mx-3">
          <ProfileMenu />
          <HelpMenu />
          <NotificationMenu />
        </div>
      </div>
    );
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/index.js